<template>
  <div>
    <vs-dropdown>
      <div class="flex">
        <img class="w-5 h-5 mr-2 inline-block align-middle" :src="currentLanguage" />
        {{ $i18n.locale.toUpperCase()}}
      </div>

      <vs-dropdown-menu>
        <vs-dropdown-item v-for="([key, data], index) in Object.entries(options)"
                          :key="index"
                          @click="handleSelection(key, data)">
          <div class="flex">
            <img v-if="data.icon"
                 :src="data.icon"
                 alt=""
                 class="w-5 h-5 mr-2 inline-block align-middle" />
            {{key.toUpperCase()}}
          </div>
        </vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        options: {
          en: {
            icon: require("@/assets/images/flags/gb.svg")
          },
          bg: {
            icon: require("@/assets/images/flags/bg.svg")
          },
        },
        currentLanguage: null
      }
    },
    mounted() {
      this.currentLanguage = this.options[this.$i18n.locale].icon
    },

    methods: {
      handleSelection(lan) {
        localStorage.setItem("language", lan);
        localStorage.setItem(location.hostname + "-lang-changed", true);
        this.currentLanguage = this.options[lan].icon;
        this.$i18n.locale = lan
      }
    }
  }
</script>


